import { useMutation } from "react-query";
import { useRef } from "react";

/**Grabs the quizzes assigned to a user
 *
 * @param {userId}
 *    @userId identifies the user that we will retreive the quizzes for
 * @returns {mutation, data}
 *    @mutation the mutated hook to be used to retrieve quizzes that calss the fetch and returns.
 *    @data returns a list of quizzes as strings
 *
 */

const fetchQuizzesByUser = async (userId) => {
  const response = await fetch(
    `${process.env.REACT_APP_BACKEND_API}/threads/getUserQuizzes/${userId}`,
    {
      method: "GET",
      headers: { "Content-Type": "application/json" },
    }
  );

  const data = await response.json();
  if (response.status === 200) {
    return data.response;
  } else {
    throw new Error(`Server responded ${data} with status: ${response.status}`);
  }
};

export const useGetQuizzesByUser = () => {
  const resolveMutation = useRef(null);

  const mutation = useMutation((userId) => fetchQuizzesByUser(userId), {
    onSettled: (data, error) => {
      if (resolveMutation.current) {
        if (error) {
          resolveMutation.current.reject({ error });
        } else {
          resolveMutation.current.resolve({ data });
        }
      }
    },
  });

  const fetchQuizzesByUserWithPromise = (userId) => {
    return new Promise((resolve, reject) => {
      resolveMutation.current = { resolve, reject };
      mutation.mutate(userId);
    });
  };

  return { ...mutation, fetchQuizzesByUser: fetchQuizzesByUserWithPromise };
};